module.exports = __webpack_public_path__ + "static/media/12_digginglight.586600e4.jpg";